<template>
  <div style="text-align: center; max-width:900px; margin:auto; margin-top:100px" v-if="arkidians">
    <section
      v-if="arkidians.length>0"
    style="border-radius:15px; background-color: #ececec; margin-left: 20px; margin-right: 20px;padding-top:20px; padding-bottom:20px"
    >
      <h3>Tus arkidians</h3>

      <div class="container">
        <div class="row" style="justify-content: center; display:block;">
          <div class="container">
            <div class="row" style="justify-content: center">
              <app-arkidian
                v-for="(arkidian,index) in arkidians"
                :arkidian="arkidian"
                v-bind:key="index"
              ></app-arkidian>

              <div
                class="card card-desafio"
                style="cursor: pointer; background:#ececec"
                @click="administrar()"
              >
                <div style="padding:20px">
                  <img
                    src="public/images/arkidians/config.svg"
                    style="background-color:#e0e0e0; margin-bottom:20px; border-radius:50%; width:150px; padding:20px"
                    class="img img-rounded img-fluid"
                  />
                  <h5>Administrar</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="arkidians.length==0"
      style="border-radius:15px; background-color: #ececec; margin-left: 20px; margin-right: 20px;padding-top:20px; padding-bottom:20px"
    >
      <div style="margin:20px">
        <h2>¡Te damos la bienvenida a Arkidia!</h2>
        <img
          src="public/images/site/winner.svg"
          style="margin-bottom:20px; width:200px; padding:20px"
          class="img img-rounded img-fluid"
        />
        <h4>Primero lo primero, creá a tus Arkidians</h4>

        <p>Elegí un sobrenombre y la fecha de nacimiento, así podemos mostrarle actividades diseñadas especialmente para su edad.</p>
        <p>Luego deberás elegir un nombre de usuario y una contraseña para que tu Arkidian pueda ingresar al sitio.</p>

        <img
          style="text-align: center; padding:30px"
          src="https://s3.amazonaws.com/www.arkidia.com/public/images/mailing/sugerir.png"
          width="300"
          alt="Arkidia"
        />

        <h3>Podrás sugerir actividades</h3>

        <p>Navegando por las distintas categorías, si hay una actividad que te gusta, podrás sugerirla a tu Arkidian. ¡Será lo primero que vea cuando ingrese al sitio!</p>
        <img
          style="text-align: center; padding:30px"
          src="https://s3.amazonaws.com/www.arkidia.com/public/images/mailing/avance.png"
          width="300"
          alt="Arkidia"
        />

        <h3>Podrás ver el avance de tu Arkidian</h3>
        <p>Ingresando al perfil de tu Arkidian verás las últimas actividades que hizo, los desafíos que compartió, y los comentarios que recibieron sus desafíos</p>
        <img
          style="text-align: center; padding:30px"
          src="https://s3.amazonaws.com/www.arkidia.com/public/images/mailing/seguro.png"
          width="300"
          alt="Arkidia"
        />

        <h3>La seguridad ante todo</h3>
        <p>Si tu Arkidian no ve su desafío recién publicado ¡No te preocupes! Lo estamos revisando.</p>

        <p>La seguridad de nuestros Arkidians es lo más importante, por eso todos los comentarios y desafíos que suben son analizados y aprobados antes de ser publicados en Arkidia.</p>
        <p>
          Es importante que tu Arkidian conserve su contraseña secreta y no la comparta con nadie. Si se la olvida, siempre tendrás acceso a modificar la contraseña desde
          <b>Administar Arkidians</b>.
        </p>

        <img
          style="text-align: center; padding:30px"
          src="https://s3.amazonaws.com/www.arkidia.com/public/images/mailing/up.png"
          width="300"
          alt="Arkidia"
        />
        <br />

        <div
          v-if="arkidians.length==0"
          class="row"
          style="text-align:-webkit-center; display:block;"
        >
          <div class="container">
            <div
              class="card card-desafio"
              style="cursor: pointer; width:200px; text-align:-webkit-center"
            >
              <div style="padding:20px" @click="nuevoArkidian()">
                <h4>Agregá un arkidian</h4>
                <img
                  src="public/images/arkidians/nuevo.svg"
                  style="background-color:#e0e0e0; margin-bottom:20px; border-radius:50%; width:200px; padding:20px"
                  class="img img-rounded img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <img
      src="public/images/site/paint-grey.svg"
      id="pintura"
      alt="Miles de proyectos"
      style=" 
      margin-top:-5px;"
    />
  </div>
</template>


<script>
import Arkidian from "../arkidian/Arkidian";
import { mapGetters } from "vuex";

export default {
  name: "arkidians",
  data: function() {
    return {
      perfil: "",
      arkidians: null
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },
  methods: {
    nuevoArkidian() {
      this.$router.push({ path: "/NuevoArkidian" });
    },
    administrar() {
      this.$router.push({ path: "/Arkidians" });
    },

    buscarArkidians() {
      var self = this;

      fetch(self.pathAPI + "hijos.php?usuario_padre=" + self.userLogged.user)
        .then(response => response.json())
        .then(data => {
          if(data.mensaje==""){
            self.arkidians = []
          }else{
          self.arkidians = data;

          }
        });
    }
  },
  mounted: function() {
    this.buscarArkidians();
  },
  components: {
    appArkidian: Arkidian
  }
};
</script>

<style scoped>
.card-desafio {
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
}

.card-desafio:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.card-desafio-image {
  border-radius: 10px;
  width: 400px;
}
@media screen and (max-width: 600px) {
  .card-desafio {
    width: 250px;
    margin: 20px;
  }
  .card-desafio-image {
    border-radius: 10px;
    width: 250px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Arkidians.vue